import React, {Component} from 'react'
import {DateRangePicker, SingleDatePicker, DayPickerRangeController} from 'react-dates';
import moment from 'moment';

class RangePicker extends Component {

  constructor(props) {
    super(props)
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      firstDayOfWeek: 1,
      monthFormat: "MMMM YYYY",
      orientation: 'horizontal'
    }
  }

  componentDidMount() {
    this.handleResize();

    moment.locale(document.querySelector('html').lang);

    window.addEventListener('resize', this.handleResize.bind(this), false);
    this.refs.clearButton.addEventListener('mousedown', this.clear.bind(this))
    this.refs.datePicker.querySelector('.DateRangePickerInput').addEventListener('mousedown', this.click.bind(this))
    this.refs.datePicker.querySelector('.range-picker-before').addEventListener('mousedown', this.clickBeforeDate.bind(this))
      this.refs.datePicker.querySelector('.range-picker-arrow').addEventListener('mousedown', this.clickBeforeDate.bind(this))
    if (this.props.startDate || this.props.endDate) {
      this.refs.datePicker.querySelector('.DateRangePicker').style.display = "inline-block";
      this.refs.datePicker.querySelector('.range-picker-before').style.display = "none";
      this.setState({startDate: moment(this.props.startDate), endDate: moment(this.props.endDate)});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this), false);
    this.refs.datePicker.querySelector('.DateRangePickerInput').removeEventListener('mousedown', this.click.bind(this))
    this.refs.datePicker.querySelector('.range-picker-before').removeEventListener('mousedown', this.clickBeforeDate.bind(this))
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the current update is not linked to the first setState of the props.startdate
    if (this.state.startDate && this.state.endDate && ((prevState.startDate || this.state.startDate.unix() != moment(this.props.startDate).unix()) || (prevState.endDate || this.state.endDate.unix() != moment(this.props.endDate).unix()))) {
      // Check if the dates have changed and if we should submit on change
      if (((this.state.startDate != prevState.startDate) || (this.state.endDate != prevState.endDate)) && parseInt(this.props.submitOnChange)) {
        this.refs.datePicker.querySelectorAll('input')[0].form.submit(this.refs.datePicker.querySelector('.DateRangePickerInput__arrow'));
      }
    }

    if((prevState.startDate && this.state.stardDate == null) && (prevState.endDate && this.state.endDate == null) && parseInt(this.props.submitOnChange)){
      this.refs.datePicker.querySelectorAll('input')[0].form.submit(this.refs.datePicker.querySelector('.DateRangePickerInput__arrow'));
    }
  }


  clear() {
    this.setState({
      startDate: null,
      endDate: null,
      focusedInput: null,
    })

    if (parseInt(this.props.submitOnChange)) {
      this.refs.datePicker.querySelectorAll('input')[0].form.submit(this.refs.datePicker.querySelector('.DateRangePickerInput__arrow'));
    }
  }

  click() {
    this.setState({focusedInput: 'startDate'})
  }

  clickBeforeDate() {
    this.refs.datePicker.querySelector('.DateRangePicker').style.display = "inline-block";
    this.refs.datePicker.querySelector('.range-picker-before').style.display = "none";

    setTimeout(function () {
      this.click();
    }.bind(this), 200)
  }

  handleResize() {
    if (window.innerWidth > 768) {
      this.setState({orientation: 'horizontal'})

    }
    else {
      this.setState({orientation: 'vertical'})
    }
  }


  render() {
    return <div ref='datePicker'>
      <div className="range-picker-before" ref='beforeRangePicker'><p>{this.props.filterDate}</p></div>
      <DateRangePicker ref='datePicker2'
                       startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                       endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                       onDatesChange={({startDate, endDate}) => {
                         this.setState({startDate, endDate})
                       }} // PropTypes.func.isRequired,
                       focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                       onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,
                       firstDayOfWeek={this.state.firstDayOfWeek}
                       monthFormat={this.state.monthFormat}
                       displayFormat="DD MMM"
                       startDatePlaceholderText={this.props.startDatePlaceholderText}
                       endDatePlaceholderText={this.props.endDatePlaceholderText}
                       customArrowIcon='-'
                       orientation={this.state.orientation}
      />
      <span className="range-picker-arrow-zone"><span className="range-picker-arrow"/></span>
      <span ref="clearButton" className="range-picker-clear-zone" title="Clear value" aria-label="Clear value" style={{display: !this.state.startDate && 'none'}}><span className="range-picker-clear">×</span></span>
    </div>
  }


}


export default RangePicker



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/range-picker/RangePicker.js